import React from 'react';

const UrbanicityFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18 17.5H2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13.5 4L14 7H15M16.5 4L16 7H15M12 4L15 3L17.5 4M15 7V17"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 12.5V15M3 17.5L3 15M3 15H5.5M12 15H9.5M12 12.5V17.5M5.5 15V10.5M5.5 15H7.5M7.5 15V10.5M7.5 15H9.5M9.5 15V10.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UrbanicityFilterIcon;
